import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Auth, getIdToken } from '@angular/fire/auth';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

/**
 * Przy 401 probuje odswiezyc token Firebase (force refresh) i ponowic DOKLADNIE
 * to samo zadanie, ktore dostalo 401 - nie tylko odswiezyc token na przyszlosc.
 * Jesli odswiezenie tez sie nie uda (np. sesja Firebase faktycznie wygasla),
 * czysci lokalny stan i przekierowuje na /login, zapamietujac biezacy adres
 * w localStorage['returnPage'] - login-page.component.ts juz to odczytuje
 * i wraca tam po zalogowaniu.
 *
 * Byla to klasa HttpErrorInterceptor (error.inceptor.ts), z identyczna logika,
 * ale NIGDY nie zarejestrowana w withInterceptors([...]) w main.ts - wiec caly
 * ten kod byl martwy, a 401 nigdy nie byl automatycznie ponawiany (#1235).
 * Przepisana na funkcyjny interceptor (HttpInterceptorFn), zgodnie z konwencja
 * projektu (patrz authInterceptor w tym samym katalogu) i uzywajaca modularnego
 * @angular/fire/auth (ten sam Auth, ktorego juz uzywa AuthService), zamiast
 * przestarzalego firebase/compat/app, ktorego reszta projektu nie importuje.
 */
export const httpErrorInterceptor: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  const auth = inject(Auth);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
        return throwError(() => error);
      }

      return from(reauthenticate(auth)).pipe(
        catchError(() => {
          localStorage.clear();
          localStorage.setItem('returnPage', window.location.pathname);
          window.location.replace('/login');
          return throwError(() => error);
        }),
        switchMap((token) => {
          const retriedReq = req.clone({
            setHeaders: { Authorization: `${token}` },
          });
          return next(retriedReq);
        }),
      );
    }),
  );
};

function reauthenticate(auth: Auth): Promise<string> {
  const user = auth.currentUser;
  if (!user) {
    return Promise.reject(new Error('Brak zalogowanego uzytkownika Firebase.'));
  }
  return getIdToken(user, true).then((token) => {
    localStorage.setItem('authToken', token);
    return token;
  });
}
